import { InfoFilled } from "@element-plus/icons-vue";
// import { defineStore } from "pinia";

export interface ClassInfoArray {
    id: number,
    course_name: string,
    course_cover_url: string,
    course_introduce: string,
    who_can_watch: number,
    rank_name: string,
    tag_name: string,
    course_created_time: string,
    watch_count: number,
    platform_comment: string
}

export const useClassInfoArray = defineStore('classInfoArray', {
    state: () => ({
      classArray: [] as ClassInfoArray[]
    }),
    actions: {
        updateClassInfoArray(info: ClassInfoArray[]) {
          console.log('info is = ', info)
          this.classArray = info
          console.log('值改变了', this.classArray)
        }
    },
    getters: {
        getClassInfoArray(): ClassInfoArray[] {
          if(!this.classArray || this.classArray.id === 0){
            return []
          }else {
            return this.classArray
          }
        }
    }

})